import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    const run = async () => {
      const hash = window.location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) { nav("/login"); return; }
      const session_id = decodeURIComponent(m[1]);
      try {
        const r = await api.post("/auth/session", { session_id });
        setUser({ ...r.data, role: "customer" });
        // wipe the fragment so we don't loop
        window.history.replaceState({}, "", "/account");
        nav("/account", { replace: true, state: { user: r.data } });
      } catch (e) {
        nav("/login?error=oauth", { replace: true });
      }
    };
    run();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="font-mono-ui text-sm">Signing you in…</div>
    </div>
  );
}
